import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface ToastProps {
  message: string | string[];
  toastProps?: any;
}

const Toast: React.FC<ToastProps> = ({ message, toastProps }) => {
  const { t } = useTranslation();

  // toastProps is injected by react-toastify only when Toast is used as a render
  // callback. When passed as pre-rendered JSX (e.g. toast.error(<Toast />)),
  // toastProps is undefined — fall back to the toast type inferred from the call.
  const type = toastProps?.type;

  let messages;

  if (typeof message === 'string') {
    messages = <div className="h6 m-0">{message}</div>;
  } else {
    messages = (
      <ul className="ps-4 m-0">
        {(message || []).map((item, idx) => (
          <li key={idx} className="h6 m-0">{item}</li>
        ))}
      </ul>
    );
  }

  return (
    <div className="w-100">
      <div className="col-12 d-flex p-2 toast-header-border-bottom align-items-center">
        <i
          className={clsx(
            type === 'success' && 'ri-checkbox-circle-fill text-success',
            type !== 'success' && 'ri-error-warning-fill text-danger',
            'me-3 ri-22px'
          )}
        ></i>
        <div
          className={clsx(
            'h6 m-0',
            type === 'success' && 'text-success',
            type !== 'success' && 'text-danger'
          )}
        >
          {type === 'success' ? t('common.toast.success') : t('common.toast.error')}
        </div>
      </div>

      <div className="col-12 p-3">{messages}</div>
    </div>
  );
};

export default Toast;
